//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordAreaView from "@/components/objects/WordAreaView.vue";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "FreeInfographicImage",
  components: { WordAreaView },
  provide () {
    return {
      source: this.sourceProp
    }
  },
  props: {
    image: {
      type: Object
    },
    label: {
      type: String
    },
    user: {
      type: Object,
      default: () => {}
    },
    fetchImagePath: {
      type: String,
      default: '/public/object_images_files/$id/'
    },
    sourceProp: {
      type: String,
      default: 'objIgs'
    }
  },
  data() {
    return {
      templateValue: null
    }
  },
  computed: {
    listInfo() {
      return {
        subLabel: this.image?.sublabel || "",
        icon: this.image?.icon,
        vistat_object: this.image?.vistat_object,
        object_label: this.label,
        label: this.image?.label ?? '',
        id: this.image?.id || uuidv4(),
      }
    }
  },
  mounted() {
    this.$refs.workAreaViews.create(this.$refs.workAreaViews.$el.offsetWidth)
  },
  methods: {
    onTemplateChange(evt) {
      this.templateValue = evt
    },
  }
}
